import React from 'react';

export const LOGIN = React.lazy(() => import('../components/loginpage'));

export const DASHBOARD = React.lazy(() => import('../components/Dashboard/main'));

export const ADMIN_USERS = React.lazy(() => import('../components/adminuser/main'));

export const CLASSIC_USERS = React.lazy(() => import('../components/classicuser/main'));

export const CREATORS = React.lazy(() => import('../components/creators/main'));

export const PRODUCTS = React.lazy(() => import('../components/products/main'));

export const GIFTS = React.lazy(() => import('../components/Gift/main'));

export const ITEMS = React.lazy(() => import('../components/items/main'));

export const SELFIES = React.lazy(() => import('../components/Sellfies/main'));

export const CART = React.lazy(() => import('../components/Cart/main'));

export const BRANDS = React.lazy(() => import('../components/Brands/main'));

export const ROLES = React.lazy(() => import('../components/Roles/main'));

export const CREDIT_CODES = React.lazy(() => import('../components/CreditCodes/main'));

export const NOTIFICATION = React.lazy(() => import('../components/Notification'));

export const CREATORS_CART = React.lazy(() => import('../components/Cart/main'));

export const CUSTOMER_CART = React.lazy(() => import('../components/Cart copy/main'));

export const PROFILE = React.lazy(() => import('../components/profile'));


export const CAMPAIGN = React.lazy(() => import('../components/premium'));

export const FINANCES = React.lazy(() => import('../components/premium'));
export const GAME_CONTEST = React.lazy(() => import('../components/premium'));
export const TICKET = React.lazy(() => import('../components/premium'));
export const RAPPORT = React.lazy(() => import('../components/premium'));
export const BRIEFS_RULES = React.lazy(() => import('../components/premium'));
export const API_CONNECT = React.lazy(() => import('../components/premium'));
export const ABOUT = React.lazy(() => import('../components/premium'));
export const ACTIVITY = React.lazy(() => import('../components/premium'));





